<template>
  <v-card flat class="">
    <v-card-text>
      <v-container fluid v-show="loading || completed">
        <v-col
          v-if="!completed"
          class="justify-center align-content-center justify-content-center 
          align-center"
        >
          <v-row
            class="justify-center align-content-center justify-content-center 
          align-center"
          >
            <v-progress-circular color="primary" indeterminate />
          </v-row>
          <v-row
            class="mt-2 justify-center align-content-center justify-content-center 
          align-center"
          >
            <p class="text-body-1">Eksporterer data..</p>
          </v-row>
        </v-col>
        <v-col
          v-else
          class="justify-center align-content-center justify-content-center 
          align-center"
        >
          <template v-if="error">
            <v-row
              class="justify-start align-content-center justify-content-center 
          align-center"
            >
              <v-icon color="error">mdi-alert-circle-outline</v-icon>
              <h3 class="pl-2 text-title">Det oppstod en feil.</h3>
            </v-row>
            <v-row
              class="mt-2 justify-center align-content-center justify-content-center 
          align-center"
            >
              <p>
                Det oppstod en feil under eksportering av data. Vennligst
                <a href="mailto:nve@nve.no">kontakt oss på epost</a>
                dersom problemet vedvarer. Detaljert feilmelding: {{ error }}
              </p>
            </v-row>
          </template>
          <template v-else>
            <v-row
              class="justify-start align-content-center justify-content-center 
          align-center pb-2"
            >
              <v-icon color="primary">mdi-check-circle-outline</v-icon>
              <h3 class="pl-2 text-title">Eksport fullført</h3>
            </v-row>
            <v-row
              class="mt-2 justify-center align-content-center justify-content-center 
          align-center"
            >
              <p>
                Nedlasting vil starte automatisk i de fleste nettlesere.
                <a @click="emitExportData">Klikk her</a> dersom nedlastingen
                ikke starter i løpet av noen sekunder.
              </p>
            </v-row>
          </template>
        </v-col>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn text v-show="!loading" @click="emitStepCompleted">
        Lukk vindu
      </v-btn>
      <v-btn @click="emitStepCompleted" text v-show="loading">
        Avbryt
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ExportDataStep3",
  props: {
    loading: Boolean,
    completed: Boolean,
    error: Boolean,
  },
  methods: {
    emitStepCompleted() {
      this.$emit("step-completed");
    },
    emitExportData() {
      this.$emit("export-data");
    },
  },
};
</script>
